export default {
  settingsTitle: "Настройки ЭДО",
  rentDocuments: "Обмениваться закрывающими документами по аренде площади",
  servicesDocuments: "Обмениваться закрывающими документами по заказам услуг",
  updateSuccess: "Настройки ЭДО успешно обновлены",
  updateError: "Ошибка при обновлении настроек ЭДО",
  contractEdoEnabled: "ЭДО включено для договора",
  contractEdoDisabled: "ЭДО отключено для договора",
  contractUpdateError: "Ошибка при обновлении ЭДО договора",
  invitationNotice:
    "При выборе обмена закрывающими документами через систему ЭДО необходимо осуществить обмен приглашениями (отправить нам или принять наше до начала монтажа выставки). В этом случае закрывающие документы не будут размещаться в Личном кабинете.",
  rules:
    "Стороны обязаны информировать друг друга о невозможности обмена документами в электронном виде в случае технического сбоя внутренних систем. В этом случае в период действия такого сбоя Стороны производят обмен документами на бумажном носителе.\n" +
    "Организация ЭДО между Сторонами не отменяет использование иных способов изготовления и обмена документами между Сторонами.",
  companyInfo: "АО «ЭКСПОЦЕНТР», ИНН 7718033809",
  edoIdLabel: "Идентификационный номер в системе ЭДО Контур.Диадок:",
  edoId: "2BM-7718033809-770301001-201411210937282283051",
  legalDescription:
    "Электронный документ, заверенный квалифицированной электронной подписью в рамках системы ЭДО Контур.Диадок, обладает юридической силой оригинального документа. Оформление бумажной копии закрывающих документов не требуется."
};
